import { render, staticRenderFns } from "./APIForm.vue?vue&type=template&id=8f9ce796&"
import script from "./APIForm.vue?vue&type=script&lang=js&"
export * from "./APIForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports